import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRocket, faBoxesPacking, faHeadset, faPeopleGroup } from '@fortawesome/free-solid-svg-icons'

const Icons = () => {
  return (
    <Container className='my-5 border-bottom border-dark'>
      <Row>
        <Col lg={3} md={6} sm={12} className='d-flex flex-column align-content-center p-5'>
          <FontAwesomeIcon className='text-black-50 mb-4 display-3' icon={faRocket} /> 
          <h3 className='text-center display-6 text-info'>Fast Delivery</h3>
          <p className='fs-6 mt-3 text-center'>Fugiat exercitation irure adipisicing mollit sint velit aliqua occaecat sint.</p>
        </Col>
        <Col lg={3} md={6} sm={12} className='d-flex flex-column align-content-center p-5'>
          <FontAwesomeIcon className='text-black-50 mb-4 display-3' icon={faBoxesPacking} /> 
          <h3 className='text-center display-6 text-info'>Easy Returns</h3>
          <p className='fs-6 mt-3 text-center'>Ullamco ut do tempor in aliqua nulla.</p>
        </Col>
        <Col lg={3} md={6} sm={12} className='d-flex flex-column align-content-center p-5'>
          <FontAwesomeIcon className='text-black-50 mb-4 display-3' icon={faHeadset} /> 
          <h3 className='text-center display-6 text-info'>24/7 Contact</h3>
          <p className='fs-6 mt-3 text-center'>Lorem culpa eu minim tempor ea adipisicing.</p>
        </Col>
        <Col lg={3} md={6} sm={12} className='d-flex flex-column align-content-center p-5'>
          <FontAwesomeIcon className='text-black-50 mb-4 display-3' icon={faPeopleGroup} /> 
          <h3 className='text-center display-6 text-info'>Expert Team</h3>
          <p className='fs-6 mt-3 text-center'>Esse occaecat sit esse cillum ad non et do sint elit tempor.</p>
        </Col>
      </Row>
    </Container>
  )
}

export default Icons